<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tit">
<h2 class="titlePageTitle"><span class="bold">MOZART</span></h2>
<p class="titlePageSubtitle">A   LIFE</p>
<h2 class="titlePageAuthor"><span class="bold">Maynard Solomon</span></h2>
<p class="center"><img alt="logo" src="logo.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?13017820